module.exports = __webpack_public_path__ + "media/images/logo__crushersgc-ff2982e8a387ed3b5cc9aca847ee8962.png";